import {combineActions} from 'redux-actions'
import {arrayToSet, filterMapByKey, filterMapByKeys} from "../../../atUtils"
import * as EntitiesActionTypes from '../../../entities/actionTypes'
import {CLOSE_ALL_PANELS} from '../common/actionTypes'

export default function({
    actionTypes: {
        CLEAR,
        CLEAR_CUSTOMERS,
        CLEAR_PROJECTS,
        CLEAR_TASKS,
        EDITING_USER_ID_SET,
        EDITING_LEVEL_SET,
        LOADED_SET,
        CUSTOMERS_LOADED_SET,
        PROJECTS_LOADED_SET,
        TASKS_LOADED_SET,
        PROJECTS_TASKS_COUNT_CLEAR,
        CUSTOMERS_TASKS_COUNT_CLEAR,
        CUSTOMERS_PROJECTS_COUNT_CLEAR,
        LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA,
        LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_SUCCESS,
        LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_FAILURE,
        LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA,
        LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS,
        LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_FAILURE,
        LOAD_TASK_ASSIGNMENTS_EDITOR_DATA,
        LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS,
        LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_FAILURE,
        CHANGE_CUSTOMER_ASSIGNMENT,
        CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS,
        CHANGE_CUSTOMER_ASSIGNMENT_FAILURE,
        CHANGE_PROJECT_ASSIGNMENT,
        CHANGE_PROJECT_ASSIGNMENT_SUCCESS,
        CHANGE_PROJECT_ASSIGNMENT_FAILURE,
        CHANGE_TASK_ASSIGNMENT,
        CHANGE_TASK_ASSIGNMENT_SUCCESS,
        CHANGE_TASK_ASSIGNMENT_FAILURE,
        ASSIGN_ALL_CUSTOMERS,
        ASSIGN_ALL_CUSTOMERS_SUCCESS,
        ASSIGN_ALL_CUSTOMERS_FAILURE,
        UNASSIGN_ALL_CUSTOMERS,
        UNASSIGN_ALL_CUSTOMERS_SUCCESS,
        UNASSIGN_ALL_CUSTOMERS_FAILURE,
        ASSIGN_ALL_PROJECTS,
        ASSIGN_ALL_PROJECTS_SUCCESS,
        ASSIGN_ALL_PROJECTS_FAILURE,
        UNASSIGN_ALL_PROJECTS,
        UNASSIGN_ALL_PROJECTS_SUCCESS,
        UNASSIGN_ALL_PROJECTS_FAILURE,
        ASSIGN_ALL_TASKS,
        ASSIGN_ALL_TASKS_SUCCESS,
        ASSIGN_ALL_TASKS_FAILURE,
        UNASSIGN_ALL_TASKS,
        UNASSIGN_ALL_TASKS_SUCCESS,
        UNASSIGN_ALL_TASKS_FAILURE,
        CHANGE_ALL_ASSIGNMENTS,
        CHANGE_ALL_ASSIGNMENTS_SUCCESS,
        CHANGE_ALL_ASSIGNMENTS_FAILURE,
        CUSTOMERS_SEARCH_OPEN_SET,
        CUSTOMERS_SEARCH_TEXT_SET,
        PROJECTS_SEARCH_OPEN_SET,
        PROJECTS_SEARCH_TEXT_SET,
        TASKS_SEARCH_OPEN_SET,
        TASKS_SEARCH_TEXT_SET,
    }
}) {
    return {
        initialState: {
            editingUserId: null,
            editingLevel: {
                customerId: null,
                projectId: null,
            },
            customerIdsOrder: [],
            projectIdsOrder: [],
            taskIdsOrder: [],
            canManageParentCustomer: false,
            canManageParentProject: false,
            canWorkCustomerIds: {},
            canManageCustomerIds: {},
            canManageCustomerExcludeSelfIds: {},
            canWorkProjectIds: {},
            canManageProjectIds: {},
            canManageProjectExcludeSelfIds: {},
            canWorkTaskIds: {},
            canManageTaskIds: {},
            projectCountsByCustomers: {},
            taskCountsByCustomers: {},
            taskCountsByProjects: {},
            futureCustomersAssigned: false,
            someCustomersOrLowerAssigned: false,
            allCustomersAssigned: false,
            futureProjectsAssigned: false,
            someProjectsOrLowerAssigned: false,
            allProjectsAssigned: false,
            futureTasksAssigned: false,
            someTasksAssigned: false,
            allTasksAssigned: false,
            loading: false,
            loaded: false,
            customersLoaded: false,
            projectsLoaded: false,
            tasksLoaded: false,
            changingCustomerAssignments: {},
            changingProjectAssignments: {},
            changingTaskAssignments: {},
            customersSearchOpen: false,
            customersSearchText: '',
            projectsSearchOpen: false,
            projectsSearchText: '',
            tasksSearchOpen: false,
            tasksSearchText: '',
            changingAllAssignments: false,
            viewerCanManageCustomerIds: {},
            viewerCanManageProjectIds: {},
        },
        handlers: {
            [LOADED_SET]: (state, {payload: loaded}) => ({
                ...state,
                loaded
            }),
            [CUSTOMERS_LOADED_SET]: (state, {payload: customersLoaded}) => ({
                ...state,
                customersLoaded
            }),
            [PROJECTS_LOADED_SET]: (state, {payload: projectsLoaded}) => ({
                ...state,
                projectsLoaded
            }),
            [TASKS_LOADED_SET]: (state, {payload: tasksLoaded}) => ({
                ...state,
                tasksLoaded
            }),
            [CLEAR]: (state) => ({
                ...state,
                editingLevel: {
                    customerId: null,
                    projectId: null,
                },
                customerIdsOrder: [],
                projectIdsOrder: [],
                taskIdsOrder: [],
                canWorkCustomerIds: {},
                canManageCustomerIds: {},
                canManageCustomerExcludeSelfIds: {},
                canWorkProjectIds: {},
                canManageProjectIds: {},
                canManageProjectExcludeSelfIds: {},
                canWorkTaskIds: {},
                canManageTaskIds: {},
                projectCountsByCustomers: {},
                taskCountsByCustomers: {},
                taskCountsByProjects: {},
                loading: false,
                customersSearchOpen: false,
                customersSearchText: '',
                projectsSearchOpen: false,
                projectsSearchText: '',
                tasksSearchOpen: false,
                tasksSearchText: '',
                canManageParentCustomer: false,
                canManageParentProject: false,
            }),
            [CLEAR_CUSTOMERS]: (state) => ({
                ...state,
                customerIdsOrder: [],
                canManageCustomerIds: {},
                canManageCustomerExcludeSelfIds: {},
                canWorkCustomerIds: {},
                projectCountsByCustomers: {},
                taskCountsByCustomers: {},
                futureCustomersAssigned: false,
                allCustomersAssigned: false,
                someCustomersOrLowerAssigned: false,
                customersLoaded: false,
            }),
            [CLEAR_PROJECTS]: (state) => ({
                ...state,
                projectIdsOrder: [],
                canManageProjectIds: {},
                canManageProjectExcludeSelfIds: {},
                canWorkProjectIds: {},
                taskCountsByProjects: {},
                futureProjectsAssigned: false,
                allProjectsAssigned: false,
                someProjectsOrLowerAssigned: false,
                projectsLoaded: false,
                canManageParentCustomer: false,
            }),
            [CLEAR_TASKS]: (state) => ({
                ...state,
                taskIdsOrder: [],
                canManageTaskIds: {},
                canWorkTaskIds: {},
                futureTasksAssigned: false,
                allTasksAssigned: false,
                someTasksAssigned: false,
                tasksLoaded: false,
                canManageParentCustomer: false,
                canManageParentProject: false,
            }),
            [EDITING_USER_ID_SET]: (state, {payload: editingUserId}) => ({
                ...state,
                editingUserId,
            }),
            [EDITING_LEVEL_SET]: (state, {payload: editingLevel}) => ({
                ...state,
                editingLevel: {
                    ...state.editingLevel,
                    ...editingLevel
                }
            }),
            [CUSTOMERS_SEARCH_OPEN_SET]: (state, {payload: customersSearchOpen}) => ({
                ...state,
                customersSearchOpen,
            }),
            [CUSTOMERS_SEARCH_TEXT_SET]: (state, {payload: customersSearchText}) => ({
                ...state,
                customersSearchText,
            }),
            [PROJECTS_SEARCH_OPEN_SET]: (state, {payload: projectsSearchOpen}) => ({
                ...state,
                projectsSearchOpen,
            }),
            [PROJECTS_SEARCH_TEXT_SET]: (state, {payload: projectsSearchText}) => ({
                ...state,
                projectsSearchText,
            }),
            [TASKS_SEARCH_OPEN_SET]: (state, {payload: tasksSearchOpen}) => ({
                ...state,
                tasksSearchOpen,
            }),
            [TASKS_SEARCH_TEXT_SET]: (state, {payload: tasksSearchText}) => ({
                ...state,
                tasksSearchText,
            }),
            [PROJECTS_TASKS_COUNT_CLEAR]: (state, {payload: projectIds}) => ({
                ...state,
                taskCountsByProjects: filterMapByKeys(state.taskCountsByProjects, projectIds),
            }),
            [CUSTOMERS_TASKS_COUNT_CLEAR]: (state, {payload: customerIds}) => ({
                ...state,
                taskCountsByCustomers: filterMapByKeys(state.taskCountsByCustomers, customerIds),
            }),
            [CUSTOMERS_PROJECTS_COUNT_CLEAR]: (state, {payload: customerIds}) => ({
                ...state,
                projectCountsByCustomers: filterMapByKeys(state.projectCountsByCustomers, customerIds),
            }),
            [combineActions(
                LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA,
                LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA,
                LOAD_TASK_ASSIGNMENTS_EDITOR_DATA,
            )]: (state) => ({
                ...state,
                loading: true,
            }),
            [combineActions(
                LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_FAILURE,
                LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_FAILURE,
                LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_FAILURE,
            )]: (state) => ({
                ...state,
                loading: false,
            }),
            [LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_SUCCESS]: (state, {
                payload: {
                    customerIds,
                    canWorkCustomerIds,
                    canManageCustomerIds,
                    canManageCustomerExcludeSelfIds,
                    projectCounts,
                    taskCounts,
                    futureCustomersAssigned,
                    someCustomersOrLowerAssigned,
                    allCustomersAssigned,
                    viewerCanManageCustomerIds,
                },
            }) => ({
                ...state,
                customerIdsOrder: [...state.customerIdsOrder, ...customerIds],
                canWorkCustomerIds: {...state.canWorkCustomerIds, ...arrayToSet(canWorkCustomerIds)},
                canManageCustomerIds: {...state.canManageCustomerIds, ...arrayToSet(canManageCustomerIds)},
                canManageCustomerExcludeSelfIds: {...state.canManageCustomerExcludeSelfIds, ...arrayToSet(canManageCustomerExcludeSelfIds)},
                projectCountsByCustomers: {
                    ...state.projectCountsByCustomers,
                    ...projectCounts,
                },
                taskCountsByCustomers: {
                    ...state.taskCountsByCustomers,
                    ...taskCounts,
                },
                futureCustomersAssigned,
                someCustomersOrLowerAssigned,
                allCustomersAssigned,
                loading: false,
                viewerCanManageCustomerIds: {...state.viewerCanManageCustomerIds, ...arrayToSet(viewerCanManageCustomerIds)},
            }),
            [LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS]: (state, {
                payload: {
                    canManageParentCustomer,
                    projectIds,
                    canWorkProjectIds,
                    canManageProjectIds,
                    canManageProjectExcludeSelfIds,
                    taskCounts,
                    futureProjectsAssigned,
                    someProjectsOrLowerAssigned,
                    allProjectsAssigned,
                    viewerCanManageProjectIds,
                },
            }) => ({
                ...state,
                canManageParentCustomer: canManageParentCustomer,
                projectIdsOrder: [...state.projectIdsOrder, ...projectIds],
                canWorkProjectIds: {...state.canWorkProjectIds, ...arrayToSet(canWorkProjectIds)},
                canManageProjectIds: {...state.canManageProjectIds, ...arrayToSet(canManageProjectIds)},
                canManageProjectExcludeSelfIds: {...state.canManageProjectExcludeSelfIds, ...arrayToSet(canManageProjectExcludeSelfIds)},
                taskCountsByProjects: {
                    ...state.taskCountsByProjects,
                    ...taskCounts,
                },
                futureProjectsAssigned,
                someProjectsOrLowerAssigned,
                allProjectsAssigned,
                loading: false,
                viewerCanManageProjectIds: {...state.viewerCanManageProjectIds, ...arrayToSet(viewerCanManageProjectIds)},
            }),
            [LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS]: (state, {
                payload: {
                    canManageParentCustomer,
                    canManageParentProject,
                    taskIds,
                    canWorkTaskIds,
                    canManageTaskIds,
                    futureTasksAssigned,
                    someTasksAssigned,
                    allTasksAssigned
                },
            }) => ({
                ...state,
                canManageParentCustomer: canManageParentCustomer,
                canManageParentProject: canManageParentProject,
                taskIdsOrder: [...state.taskIdsOrder, ...taskIds],
                canWorkTaskIds: {...state.canWorkTaskIds, ...arrayToSet(canWorkTaskIds)},
                canManageTaskIds: {...state.canManageTaskIds, ...arrayToSet(canManageTaskIds)},
                futureTasksAssigned,
                someTasksAssigned,
                allTasksAssigned,
                loading: false,
            }),
            [CHANGE_CUSTOMER_ASSIGNMENT]: (state, {payload: {customerId}}) => ({
                ...state,
                changingCustomerAssignments: {...state.changingCustomerAssignments, [customerId]: true}
            }),
            [CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS]: (state, {payload: {customerId, canWork, canManage, someAssigned, allAssigned}}) => ({
                ...state,
                canWorkCustomerIds: {
                    ...state.canWorkCustomerIds,
                    [customerId]: canWork
                },
                canManageCustomerIds: {
                    ...state.canManageCustomerIds,
                    [customerId]: canManage
                },
                canManageCustomerExcludeSelfIds: filterMapByKey(state.canManageCustomerExcludeSelfIds, customerId),
                changingCustomerAssignments: filterMapByKey(state.changingCustomerAssignments, customerId),
                someCustomersOrLowerAssigned: someAssigned,
                allCustomersAssigned: allAssigned,
            }),
            [CHANGE_CUSTOMER_ASSIGNMENT_FAILURE]: (state, {payload: {customerId}}) => ({
                ...state,
                changingCustomerAssignments: filterMapByKey(state.changingCustomerAssignments, customerId)
            }),
            [ASSIGN_ALL_CUSTOMERS_SUCCESS]: (state, {payload: {canManageCustomerIds, allCustomersAssigned, someCustomersOrLowerAssigned}}) => ({
                ...state,
                canManageCustomerIds,
                allCustomersAssigned,
                someCustomersOrLowerAssigned,
                canManageCustomerExcludeSelfIds: {},
            }),
            [CHANGE_PROJECT_ASSIGNMENT]: (state, {payload: {projectId}}) => ({
                ...state,
                changingProjectAssignments: {...state.changingProjectAssignments, [projectId]: true}
            }),
            [CHANGE_PROJECT_ASSIGNMENT_SUCCESS]: (state, {payload: {projectId, canWork, canManage, someAssigned, allAssigned}}) => ({
                ...state,
                canWorkProjectIds: {
                    ...state.canWorkProjectIds,
                    [projectId]: canWork
                },
                canManageProjectIds: {
                    ...state.canManageProjectIds,
                    [projectId]: canManage
                },
                canManageProjectExcludeSelfIds: filterMapByKey(state.canManageProjectExcludeSelfIds, projectId),
                changingProjectAssignments: filterMapByKey(state.changingProjectAssignments, projectId),
                someProjectsOrLowerAssigned: someAssigned,
                allProjectsAssigned: allAssigned,
            }),
            [CHANGE_PROJECT_ASSIGNMENT_FAILURE]: (state, {payload: {projectId}}) => ({
                ...state,
                changingProjectAssignments: filterMapByKey(state.changingProjectAssignments, projectId)
            }),
            [ASSIGN_ALL_PROJECTS_SUCCESS]: (state, {payload: {canManageProjectIds, allProjectsAssigned, someProjectsOrLowerAssigned}}) => ({
                ...state,
                canManageProjectIds,
                allProjectsAssigned,
                someProjectsOrLowerAssigned,
                canManageProjectExcludeSelfIds: {},
            }),
            [CHANGE_TASK_ASSIGNMENT]: (state, {payload: {taskId}}) => ({
                ...state,
                changingTaskAssignments: {...state.changingTaskAssignments, [taskId]: true}
            }),
            [CHANGE_TASK_ASSIGNMENT_SUCCESS]: (state, {payload: {taskId, canWork, canManage, someAssigned, allAssigned}}) => ({
                ...state,
                canWorkTaskIds: {
                    ...state.canWorkTaskIds,
                    [taskId]: canWork
                },
                canManageTaskIds: {
                    ...state.canManageTaskIds,
                    [taskId]: canManage
                },
                changingTaskAssignments: filterMapByKey(state.changingTaskAssignments, taskId),
                someTasksAssigned: someAssigned,
                allTasksAssigned: allAssigned,
            }),
            [CHANGE_TASK_ASSIGNMENT_FAILURE]: (state, {payload: {taskId}}) => ({
                ...state,
                changingTaskAssignments: filterMapByKey(state.changingTaskAssignments, taskId)
            }),
            [ASSIGN_ALL_TASKS_SUCCESS]: (state, {payload: {canManageTaskIds, allTasksAssigned, someTasksAssigned}}) => ({
                ...state,
                canManageTaskIds,
                allTasksAssigned,
                someTasksAssigned,
            }),
            [CHANGE_ALL_ASSIGNMENTS]: (state) => ({
                ...state,
                changingAllAssignments: true
            }),
            [combineActions(
                CHANGE_ALL_ASSIGNMENTS_SUCCESS,
                CHANGE_ALL_ASSIGNMENTS_FAILURE
            )]: (state) => ({
                ...state,
                changingAllAssignments: false
            }),
            [EntitiesActionTypes.CUSTOMERS_REMOVE]: (state, {payload: customerIds}) => ({
                ...state,
                customerIdsOrder: state.customerIdsOrder.filter(tId => !arrayToSet(customerIds)[tId]),
                canManageCustomerIds: filterMapByKeys(state.canManageCustomerIds, customerIds),
                canManageCustomerExcludeSelfIds: {},
                canWorkCustomerIds: filterMapByKeys(state.canWorkCustomerIds, customerIds),
                changingCustomerAssignments: filterMapByKeys(state.changingCustomerAssignments, customerIds)
            }),
            [EntitiesActionTypes.PROJECTS_REMOVE]: (state, {payload: projectIds}) => ({
                ...state,
                projectIdsOrder: state.projectIdsOrder.filter(tId => !arrayToSet(projectIds)[tId]),
                canManageProjectIds: filterMapByKeys(state.canManageProjectIds, projectIds),
                canManageProjectExcludeSelfIds: filterMapByKeys(state.canManageProjectExcludeSelfIds, projectIds),
                canWorkProjectIds: filterMapByKeys(state.canWorkProjectIds, projectIds),
                changingProjectAssignments: filterMapByKeys(state.changingProjectAssignments, projectIds)
            }),
            [EntitiesActionTypes.TASKS_REMOVE]: (state, {payload: taskIds}) => ({
                ...state,
                taskIdsOrder: state.taskIdsOrder.filter(tId => !arrayToSet(taskIds)[tId]),
                canManageTaskIds: filterMapByKeys(state.canManageTaskIds, taskIds),
                canWorkTaskIds: filterMapByKeys(state.canWorkTaskIds, taskIds),
                changingTaskAssignments: filterMapByKeys(state.changingTaskAssignments, taskIds)
            }),
            [CLOSE_ALL_PANELS]: (state) => ({
                ...state,
                editingUserId: null,
                editingLevel: {
                    customerId: null,
                    projectId: null,
                },
                customerIdsOrder: [],
                projectIdsOrder: [],
                taskIdsOrder: [],
                canManageParentCustomer: false,
                canManageParentProject: false,
                canWorkCustomerIds: {},
                canManageCustomerIds: {},
                canWorkProjectIds: {},
                canManageProjectIds: {},
                canManageProjectExcludeSelfIds: {},
                canWorkTaskIds: {},
                canManageTaskIds: {},
                projectCountsByCustomers: {},
                taskCountsByCustomers: {},
                taskCountsByProjects: {},
                futureCustomersAssigned: false,
                someCustomersOrLowerAssigned: false,
                allCustomersAssigned: false,
                futureProjectsAssigned: false,
                someProjectsOrLowerAssigned: false,
                allProjectsAssigned: false,
                futureTasksAssigned: false,
                someTasksAssigned: false,
                allTasksAssigned: false,
                loading: false,
                loaded: false,
                customersLoaded: false,
                projectsLoaded: false,
                tasksLoaded: false,
                changingCustomerAssignments: {},
                changingProjectAssignments: {},
                changingTaskAssignments: {},
                customersSearchOpen: false,
                customersSearchText: '',
                projectsSearchOpen: false,
                projectsSearchText: '',
                tasksSearchOpen: false,
                tasksSearchText: '',
                changingAllAssignments: false,
            }),
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/hierarchyAssignmentsEditor/reducerGenerator.js